export const Settings = {
  REEL_COUNT: 5,
  SYMBOLS_VISIBLE: 4,
  SYMBOL_WIDTH: 206, // Maximum symbol width
  SYMBOL_HEIGHT: 206, // Maximum symbol height
  GRID_SYMBOL_WIDTH: 200,
  GRID_SYMBOL_HEIGHT: 200,
  FREE_SPIN_ROUNDS: 15,
  COIN_VALUE_FONT_SIZE_MULTIPLIER: 0.24, // Font size for coin values as percentage of symbol height (25%)

  APP: {
    RGS_PROVIDER: "PopiPlay",
    CURRENCY: "FUN",
    GAME_NAME: "GriffinsVault",
    GAME_NAME_FULL: "Griffin's Vault",
  },
  LANGUAGES: [
    { value: "en", label: "EN" },
    { value: "sr-Latn", label: "SR" },
  ],
};

// Game layout configuration - pre-generated arrays for reel and symbol indices
export const GAME_LAYOUT = {
  REEL_COUNT: Settings.REEL_COUNT,
  SYMBOLS_VISIBLE: Settings.SYMBOLS_VISIBLE,
  SYMBOL_INDICES: Array.from(
    { length: Settings.SYMBOLS_VISIBLE },
    (_, idx) => idx
  ),
  REEL_INDICES: Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx),
  MIDDLE_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2), // Middle reel index (for 5 reels = 2)
  SECOND_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2) - 1, // Second reel index (for 5 reels = 1)
};

export const APP_VERSION = "21.01.2026 - 15:40";

// Stage dimensions - centralized configuration
export const STAGE_DIMENSIONS = {
  MAX_WIDTH: 3840, // Maximum stage width for UI constraint and background scaling
  MAX_HEIGHT: 3840, // Maximum background height (for reference)
};
